/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

package systems.frictionless.impulse.browser.composable.component

import androidx.compose.runtime.Composable
import kotlinx.collections.immutable.persistentListOf
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import systems.frictionless.impulse.browser.style.AppStyleSheet
import systems.frictionless.impulse.rest.client.model.RestResponse

@Composable
fun FullScreenErrorMessage(
    message: String,
    errorType: RestResponse.Failure<*>,
    retry: () -> Unit
) {
    CenteredOnScreen(persistentListOf(AppStyleSheet.largeWidth, AppStyleSheet.ignoreCenteringOnMobileLandscape)) {
        WhiteBox {
            H1 {
                Text(message)
            }
            Div(attrs = {
                classes(AppStyleSheet.errorMessage, AppStyleSheet.fullScreenErrorTextContainer)
            }) {
                Text(
                    when (errorType) {
                        is RestResponse.Failure.Client -> {
                            "Unable to process response from the server."
                        }
                        is RestResponse.Failure.Server -> {
                            "Server error: ${errorType.serverError.errorMessage}."
                        }
                        is RestResponse.Failure.Connection -> {
                            "Unable to connect to the server. Is your internet connection working?"
                        }
                        else -> {
                            throw UnsupportedOperationException("I don't know how to process error of type `$errorType`")
                        }
                    }
                )
            }
            Button(attrs = {
                classes(AppStyleSheet.blueButton)
                onClick {
                    retry()
                }
            }) {
                Text("Retry")
            }
        }
    }
}
